import React, { useState } from "react";
import { Controller } from "react-hook-form";
import ModernShiftPicker from "./ModernShiftPicker";

const Step1ServiceDetails = ({
  register,
  control,
  errors,
  getValues,
  setValue,
  addShift,
  removeShift,
  handleShiftChange,
  defaultShifts,
}) => {
  const [serviceType, setServiceType] = useState("1");

  const handleChange = (e) => {
    setServiceType(e.target.value);
  };

  return (
    <div className="space-y-4">
      {/* Service Type Selection */}
      <div>
        <h3 className="text-sm font-semibold text-foreground mb-3">
          Select Service Type
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          <div
            className={`relative border rounded-md p-2.5 cursor-pointer transition-all duration-200 ${
              serviceType === "1"
                ? "border-brand-pink bg-brand-pink/5"
                : "border-border hover:border-brand-pink/50"
            }`}
          >
            <input
              type="radio"
              {...register("serviceType")}
              defaultChecked
              value="1"
              onChange={handleChange}
              id="service1"
              className="sr-only"
            />
            <label htmlFor="service1" className="flex items-center cursor-pointer">
              <div className="flex-1">
                <span className="text-sm font-medium text-foreground">
                  Standing Post
                </span>
              </div>
              {serviceType === "1" && (
                <div className="ml-2">
                  <div className="w-4 h-4 rounded-full bg-brand-pink flex items-center justify-center">
                    <svg
                      className="w-2.5 h-2.5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </label>
          </div>

          <div
            className={`relative border rounded-md p-2.5 cursor-pointer transition-all duration-200 ${
              serviceType === "2"
                ? "border-brand-pink bg-brand-pink/5"
                : "border-border hover:border-brand-pink/50"
            }`}
          >
            <input
              type="radio"
              {...register("serviceType")}
              value="2"
              onChange={handleChange}
              id="service2"
              className="sr-only"
            />
            <label htmlFor="service2" className="flex items-center cursor-pointer">
              <div className="flex-1">
                <span className="text-sm font-medium text-foreground">
                  Mobile Patrol
                </span>
              </div>
              {serviceType === "2" && (
                <div className="ml-2">
                  <div className="w-4 h-4 rounded-full bg-brand-pink flex items-center justify-center">
                    <svg
                      className="w-2.5 h-2.5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </label>
          </div>

          <div
            className={`relative border rounded-md p-2.5 cursor-pointer transition-all duration-200 ${
              serviceType === "3"
                ? "border-brand-pink bg-brand-pink/5"
                : "border-border hover:border-brand-pink/50"
            }`}
          >
            <input
              type="radio"
              {...register("serviceType")}
              value="3"
              onChange={handleChange}
              id="service3"
              className="sr-only"
            />
            <label htmlFor="service3" className="flex items-center cursor-pointer">
              <div className="flex-1">
                <span className="text-sm font-medium text-foreground">
                  Workplace Security
                </span>
              </div>
              {serviceType === "3" && (
                <div className="ml-2">
                  <div className="w-4 h-4 rounded-full bg-brand-pink flex items-center justify-center">
                    <svg
                      className="w-2.5 h-2.5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </label>
          </div>

          <div
            className={`relative border rounded-md p-2.5 cursor-pointer transition-all duration-200 ${
              serviceType === "4"
                ? "border-brand-pink bg-brand-pink/5"
                : "border-border hover:border-brand-pink/50"
            }`}
          >
            <input
              type="radio"
              {...register("serviceType")}
              value="4"
              onChange={handleChange}
              id="service4"
              className="sr-only"
            />
            <label htmlFor="service4" className="flex items-center cursor-pointer">
              <div className="flex-1">
                <span className="text-sm font-medium text-foreground">
                  Event Security
                </span>
              </div>
              {serviceType === "4" && (
                <div className="ml-2">
                  <div className="w-4 h-4 rounded-full bg-brand-pink flex items-center justify-center">
                    <svg
                      className="w-2.5 h-2.5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </label>
          </div>

          <div
            className={`relative border rounded-md p-2.5 cursor-pointer transition-all duration-200 ${
              serviceType === "5"
                ? "border-brand-pink bg-brand-pink/5"
                : "border-border hover:border-brand-pink/50"
            }`}
          >
            <input
              type="radio"
              {...register("serviceType")}
              value="5"
              onChange={handleChange}
              id="service5"
              className="sr-only"
            />
            <label htmlFor="service5" className="flex items-center cursor-pointer">
              <div className="flex-1">
                <span className="text-sm font-medium text-foreground">
                  Executive Protection
                </span>
              </div>
              {serviceType === "5" && (
                <div className="ml-2">
                  <div className="w-4 h-4 rounded-full bg-brand-pink flex items-center justify-center">
                    <svg
                      className="w-2.5 h-2.5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </label>
          </div>

          <div
            className={`relative border rounded-md p-2.5 cursor-pointer transition-all duration-200 ${
              serviceType === "6"
                ? "border-brand-pink bg-brand-pink/5"
                : "border-border hover:border-brand-pink/50"
            }`}
          >
            <input
              type="radio"
              {...register("serviceType")}
              value="6"
              onChange={handleChange}
              id="service6"
              className="sr-only"
            />
            <label htmlFor="service6" className="flex items-center cursor-pointer">
              <div className="flex-1">
                <span className="text-sm font-medium text-foreground">
                  Emergency
                </span>
              </div>
              {serviceType === "6" && (
                <div className="ml-2">
                  <div className="w-4 h-4 rounded-full bg-brand-pink flex items-center justify-center">
                    <svg
                      className="w-2.5 h-2.5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </label>
          </div>
        </div>
        {errors.serviceType && (
          <p className="text-destructive text-xs mt-1">{errors.serviceType.message}</p>
        )}
      </div>

      {/* Hourly Pay Rate */}
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Max. Hourly Pay Rate ($)
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-muted-foreground text-sm font-medium">$</span>
          </div>
          <input
            type="number"
            {...register("hourlyPayRate")}
            className="block w-full pl-8 pr-4 py-2.5 border border-input rounded-lg focus:ring-2 focus:ring-ring focus:border-ring transition-all duration-200 text-sm placeholder-muted-foreground bg-background"
            placeholder="48"
          />
        </div>
        {errors.hourlyPayRate && (
          <p className="text-destructive text-xs mt-1">{errors.hourlyPayRate.message}</p>
        )}
      </div>

      {/* Shifts */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-semibold text-foreground">Shifts</h3>
        </div>
        {/* <p className="text-xs text-gray-500 mb-3">
          Shifts must be scheduled at least 2 days in advance
        </p> */}
        <Controller
          name="shifts"
          control={control}
          defaultValue={defaultShifts}
          render={({ field }) => (
            <div className="space-y-3">
              {field.value.map((shift, index) => (
                <ModernShiftPicker
                  key={index}
                  index={index}
                  shift={shift}
                  onShiftChange={(updatedShift) =>
                    handleShiftChange(index, updatedShift)
                  }
                  onRemove={() => removeShift(index)}
                  canRemove={field.value.length > 1}
                  errors={errors?.shifts?.[index]}
                />
              ))}
              
              <button
                type="button"
                onClick={addShift}
                className="w-full py-2 px-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-[#CC457D] hover:text-[#CC457D] transition-all duration-200 font-medium text-sm flex items-center justify-center"
              >
                <svg className="mr-1" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 5v14"></path>
                  <path d="M5 12h14"></path>
                </svg>
                Add Another Shift
              </button>
            </div>
          )}
        />
        {errors.shifts && typeof errors.shifts.message === "string" && (
          <p className="text-destructive text-xs mt-1">{errors.shifts.message}</p>
        )}
      </div>

      {/* Memo */}
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Memo (Optional)
        </label>
        <textarea
          {...register("memo")}
          rows={3}
          className="block w-full px-4 py-2.5 border border-input rounded-lg focus:ring-2 focus:ring-ring focus:border-ring transition-all duration-200 text-sm placeholder-muted-foreground resize-none bg-background"
          placeholder="Additional notes or instructions..."
        />
        {errors.memo && (
          <p className="text-destructive text-xs mt-1">{errors.memo.message}</p>
        )}
      </div>
    </div>
  );
};

export default Step1ServiceDetails;
